<template>
  <h2 class="ba-h5" :data-cy="DATA_CY.DIALOG_TITLE">
    <slot />
  </h2>
</template>

<script setup lang="ts">
import { DATA_CY } from '~/constants/strings'
</script>
